import React from "react";
import styled from "styled-components";

// 공통 컴포넌트 스타일
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Container_3 = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Container_2 = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Section = styled.section`
  padding: 4rem 0;
`;

const LittleSection = styled.section`
  padding: 2rem 0;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center;
  color: #22365c;

  &:after {
    content: "";
    display: block;
    width: 50px;
    height: 3px;
    background-color: #1a4b8c;
    margin: 1rem auto 0;
  }
`;

const Button = styled.button`
  display: inline-block;
  padding: ${(props) => (props.small ? "0.5rem 1rem" : "0.75rem 1.5rem")};
  background-color: ${(props) => (props.primary ? "#22365c" : "#fff")};
  color: ${(props) => (props.primary ? "#fff" : "#22365c")};
  border: 1px solid #22365c;
  border-radius: 4px;
  font-size: ${(props) => (props.small ? "0.9rem" : "1rem")};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) =>
      props.primary ? "#0d3b76" : "rgba(26, 75, 140, 0.1)"};
  }

  &:disabled {
    background-color: #adb5bd;
    border-color: #adb5bd;
    color: #fff;
    cursor: not-allowed;
  }
`;

// 공통 컴포넌트 내보내기
export {
  Container,
  Section,
  SectionTitle,
  Button,
  LittleSection,
  Container_2,
  Container_3,
};
